import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import colors from '../../../../../utils/colors';
import styles from './statsDesktop.module.scss';
import { connect } from 'react-redux';
import StatsBox from '../StatsBox';
import { ReactComponent as MoneyIcon } from '../../../../../assets/images/money.svg';
import { ReactComponent as StorageIcon } from '../../../../../assets/images/storage.svg';

const mapStateToProps = (state) => {
    return {
        alignment: state.common.currency.alignment
    };
};

const StatsDesktop = ({currency, alignment, totalEarned, totalStreams, totalStorage}) => {
    const { t } = useTranslation();

    const formattedTotalEarned = alignment === 'left'
        ? `${currency} ${totalEarned}`
        : `${totalEarned} ${currency}`;

    return (
        <Box className={styles.stats}>
            <StatsBox
                label={t('TotalEarned')}
                Icon={MoneyIcon}
                formattedValue={formattedTotalEarned}
                color={colors.primary}
            />
            <StatsBox
                label={t('TotalStreams')}
                Icon={PlayArrowIcon}
                formattedValue={totalStreams}
                color={colors.secondary}
            />
            <StatsBox
                label={t('TotalStorage')}
                Icon={StorageIcon}
                formattedValue={`${totalStorage}/100GB`}
                color={colors.primary}
            />
        </Box>
    );
};

export default connect(mapStateToProps, null)(StatsDesktop);
